import { Component, NgZone } from '@angular/core';
import {
  ActionSheetController,
  Events,
  ModalController,
  NavController,
  Refresher
} from 'ionic-angular';
import { DiaperModalComponent } from '../../components/diaper-modal/diaper-modal';
import { FeedingModalComponent } from '../../components/feeding-modal/feeding-modal';
import { TypesModalComponent } from '../../components/types-modal/types-modal';
import { DataServiceProvider } from '../../providers/data-service/data-service';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {
  constructor(
    public navCtrl: NavController,
    public modalCtrl: ModalController,
    public actionSheetCtrl: ActionSheetController,
    public events: Events,
    private dataService: DataServiceProvider,
    private zone: NgZone
  ) {
    this.events.subscribe('updateScreen', () => {
      this.zone.run(() => {
        console.log('force update the screen');
      });
    });
    // events.subscribe('lastDiaper', (lastDiaper) => {
    //   this.updateLastDiaper(lastDiaper);
    // });
    // events.subscribe('lastFeeding', (lastFeeding) => {
    //   this.updateLastFeeding(lastFeeding);
    //   this.updateSummary();
    // });

    // this.dataService.auth.onAuthStateChanged((user:any) => {
    //   if (user) {
    //     // Last Feeding
    //     this.dataService.data.child(user.uid).child("latestFeeding").on("value", (data:any) => {
    //       this.updateLastFeeding(data.val())
    //       this.updateSummary();
    //     })
    //     // Last Diaper
    //     this.dataService.data.child(user.uid).child("latestDiaper").on("value", (data:any) => {
    //       this.updateLastDiaper(data.val())
    //       this.updateSummary();
    //     })
    //   }
    // })

    // let refreshId = setInterval(() => {
    //   //  this.updateLastDiaper(null)
    //   //  this.updateLastFeeding(null)
    //    this.updateSummary()
    //  }, 60 * 1000);

    // let loadId = setInterval(() => {
    //   if(this.dataService.latestDiaper && this.dataService.latestFeeding){
    //     // this.updateLastDiaper(null)
    //     // this.updateLastFeeding(null)
    //     this.updateSummary()
    //     clearInterval(loadId);
    //   }
    // }, 250);
  }

  // updateLastDiaper(lastDiaper:any){
  //   if(lastDiaper == null && this.dataService.latestDiaper){
  //     lastDiaper = this.lastDiaper;
  //   }
  //   if(lastDiaper){
  //     let millis = moment().valueOf() - moment(lastDiaper.timestamp).valueOf();
  //     lastDiaper.hours = moment(millis).utc().hours();
  //     lastDiaper.minutes = moment(millis).minutes();
  //     this.lastDiaper = lastDiaper;
  //   }
  // }

  // updateLastFeeding(lastFeeding:any){
  //   if(lastFeeding == null && this.lastFeeding){
  //     lastFeeding = this.lastFeeding;
  //   }
  //   if(lastFeeding){
  //     let millis = moment().valueOf() - moment(lastFeeding.timestamp).valueOf();
  //     lastFeeding.hours = moment(millis).utc().hours();
  //     lastFeeding.minutes = moment(millis).minutes();
  //     this.lastFeeding = lastFeeding;
  //   }
  // }

  ionViewDidEnter() {
    this.dataService.updateSummary();
  }

  updateView(refresher: Refresher) {
    this.dataService.updateSummary();
    this.zone.run(() => {
      console.log('force update the screen');
    });
    refresher.complete();
  }

  newFeeding() {
    let modal = this.modalCtrl.create(FeedingModalComponent, {});
    modal.present();
  }

  newDiaper() {
    let modal = this.modalCtrl.create(DiaperModalComponent, {});
    modal.present();
  }

  editTypes() {
    let modal = this.modalCtrl.create(TypesModalComponent, {});
    modal.present();
  }

  openMenu() {
    let actionSheet = this.actionSheetCtrl.create({
      title: 'Optionen',
      buttons: [
        {
          text: 'Typen bearbeiten',
          role: 'primary',
          handler: () => {
            this.editTypes();
          }
        },
        {
          text: 'Ausloggen',
          role: 'destructive',
          handler: () => {
            this.dataService.logout();
          }
        },
        {
          text: 'Abbrechen',
          role: 'cancel',
          handler: () => {}
        }
      ]
    });
    actionSheet.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts